<footer class="footer fixed-bottom">
    Banco Pichincha C.A. Todos los derechos reservados.
  </footer>